<template>
  <section>
    <template v-if="preBookingData.province_id > 0">
      <!-- Summary booking in select professional -->
      <summary-booking-select-professional v-if="$mq.phone"/>
      <section ref="sectionChooseCleaner">
        <!-- Filter -->
        <filter-professional :newBookingTime="newBookingTime"/>
        <div class="row mt-1">
          <div class="col-12" v-if="!professionals">
            <div v-if="hasPlaceLocation">
              <loader/>
            </div>
            <div class="text-center" v-else>
              <i class="fal fa-map-marked-alt fa-2x"></i>
              {{ $t('message.booking.choose_cleaner_step.alert_pin_location') }}
            </div>
          </div>
          <template v-else>
            <template v-if="professionals && professionals.length === 0">
              <div class="col-12 text-center mt-3">
                <img src="/static/img/beneat_cleaner.png" alt="" width="100">
                <div class="mt-3 text-secondary">{{ $t('message.booking.choose_cleaner_step.no_cleaner_available') }}</div>
                <template v-if="bookingState.nextAvailableData.professionals > 0">
                  <hr>
                  <div class="mt-3 text-secondary">
                    {{ $tc('message.booking.choose_cleaner_step.choosecleaner_next_avilable01',
                    bookingState.nextAvailableData.professionals) }}
                    {{ bookingState.nextAvailableData.professionals }}
                    {{ $tc('message.booking.choose_cleaner_step.choosecleaner_next_avilable02',
                    bookingState.nextAvailableData.professionals) }}
                    {{ bookingState.nextAvailableData.time }}
                  </div>
                  <button class="button button-large button-outline mt-3"
                          @click="updateBookingTime">
                    {{ $t('message.button.change_next_avilable_time') }}
                    {{ bookingState.nextAvailableData.time }}
                  </button>
                </template>
                <div class="my-3">{{ $t('message.hero.or') }}</div>
                <div class="text-secondary">{{ $t('message.professional.contact_support_team') }}</div>
                <div class="my-3 text-center">
                  <!-- <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
                    <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
                  </a> -->
                  <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
                    <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
                  </a>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="col-lg-8 col-12 p-0">
                <div class="row">
                  <div class="col-12">
                    <section id="professional-list-content">
                      <div v-for="(professional, index) in filteredProfessionals">
                        <professional :professional="professional" :index="index"/>
                      </div>
                    </section>
                  </div>
                </div>
                <div class="text-center my-4">
                  <button class="btn btn-outline-info px-4"
                          :disabled="bookingState.isFetching"
                          @click="loadMoreProfessionals"
                          v-if="bookingState.isMore"> {{ $t(isLoadMore) }}
                  </button>
                </div>
              </div>
              <!-- /.col-lg-8 -->
              <div class="col-lg-4 p-0 d-none d-lg-block" v-if="$mq.desktop">
                <div v-sticky sticky-offset="{top: 120, bottom: 20}" >
                  <professional-map
                    :filteredProfessionals="filteredProfessionals"
                    :latitude="latitude"
                    :longitude="longitude" />
                </div>
              </div>
              <!-- /.col-lg-4 -->
            </template>
          </template>
        </div>
      </section>
      <instant-booking-modal ref="instantBookingModal"/>
    </template>

    <!-- Cleaner reviews modal -->
    <cleaner-reviews-modal ref="cleanerReviewsModal"/>
    <!-- Pin location modal -->
    <pin-location-modal :settings="settings" ref="pinLocationModal" @savedLocation="setLocation" />
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import FilterProfessional from '../components/FilterProfessional'
  import i18n from '../../../helpers/i18nHelpers'
  import Loader from '../../loader/Loader'
  import moment from 'moment-timezone'
  import Notification from '../../partials/Notification'
  import Professional from '../components/Professional'
  import ProfessionalMap from '../components/ProfessionalMap'
  import SummaryBookingSelectProfessional from '../components/SummaryBookingSelectProfessional'
  import InstantBookingModal from '../../modal/InstantBookingModal'
  import CleanerReviewsModal from '../components/CleanerReviewsModal'
  import PinLocationModal from '../components/PinLocationModal'
  import { firebaseAuth } from '../../../helpers/firebaseHelpers'
  import { getRedirectResult } from 'firebase/auth'
  import userEventLogHelpers from '../../../helpers/userEventLogHelpers'
  import serviceHelpers from '../../../helpers/serviceHelpers'

  export default {
    components: {
      CleanerReviewsModal,
      FilterProfessional,
      Loader,
      Notification,
      Professional,
      ProfessionalMap,
      SummaryBookingSelectProfessional,
      InstantBookingModal,
      PinLocationModal
    },
    data () {
      return {
        serviceId: 1,
        userId: 0,
        page: 0,
        limit: 20,
        language: i18n.locale,
        selectedIndex: null,
        selectedProvinceId: 0,
        latitude: null,
        longitude: null,
        search: '',
        availableSearchProvince: [1, 4],
        hasVacuumCleaner: false,
        newBookingTime: null,
        hasPlaceLocation: false,
        displayBackButton: false,
        isExcellent: 0,
        vaccinatedProfessional: 0,
        covidTestProfessional: 0,
        settings: {
          page: 'chooseProfessionals',
          hideHeaderClose: true,
          noCloseOnBackdrop: true,
          okOnly: true
        },
        languageIds: []
      }
    },
    computed: {
      ...mapGetters({
        bookingState: 'booking/getState',
        globalState: 'globalVal/getState',
        isLoadMore: 'booking/isLoadMore',
        isLoadingProfessionals: 'booking/getIsLoadingProfessionals',
        preBookingData: 'booking/getPreBookingData',
        professionals: 'booking/getProfessionals',
        selectedProfessional: 'booking/getSelectedProfessional',
        user: 'auth/getUser'
      }),
      filteredProfessionals () {
        return this.professionals.filter((professional) => {
          let filteredProfessional = professional
          if (professional.available_location && this.search) {
            filteredProfessional = professional.available_location.toLowerCase().match(this.search.toLowerCase())
            if (this.hasVacuumCleaner) {
              filteredProfessional = (professional.available_location.toLowerCase().match(this.search.toLowerCase()) && professional.has_vacuum_cleaner)
            }
          } else {
            if (this.hasVacuumCleaner) {
              filteredProfessional = professional.has_vacuum_cleaner
            }
          }
          return filteredProfessional
        })
      }
    },
    watch: {
      selectedProfessional () {
        if (this.selectedProfessional === null) {
          this.setDisableButtons(false)
        }
      },
      professionals () {
        if (this.professionals && this.professionals.length === 0 && this.page === 0) {
          // Save No Cleaner Event
          this.saveNoCleanerEvent()
        } else {
          const displayedInstantBookingModal = localStorage.getItem('displayedInstantBookingModal')
          if (!displayedInstantBookingModal || displayedInstantBookingModal === 'false') {
            for (let key in this.professionals) {
              const professional = this.professionals[key]
              if (professional.is_favorited_user) {
                this.$refs.instantBookingModal.openModal()
                localStorage.setItem('displayedInstantBookingModal', true)
                break
              }
            }
          }
        }
      }
    },
    methods: {
      setLocation (data) {
        this.latitude = data.latitude
        this.longitude = data.longitude
        this.hasPlaceLocation = true
        this.loadProfessionals()
        // Add or update latitude and longitude for preBooking data
        this.$store.commit('booking/UPDATE_PRE_BOOKING_DATA', { key: 'latitude', value: data.latitude })
        this.$store.commit('booking/UPDATE_PRE_BOOKING_DATA', { key: 'longitude', value: data.longitude })
        // Update user place latitude and longitude for non location user place
        if (this.preBookingData.user_place && this.preBookingData.user_place.id) {
          const submitData = { ...this.preBookingData.user_place }
          submitData.latitude = data.latitude
          submitData.longitude = data.longitude
          this.$store.dispatch('listing/SAVE_USER_PLACE', submitData)
        }
      },
      updateSearch (data) {
        this.search = data
      },
      updateHasVacuumCleaner (status) {
        this.hasVacuumCleaner = status
      },
      checkSearchProvince () {
        return this.availableSearchProvince.includes(this.selectedProvinceId)
      },
      saveNoCleanerEvent () {
        const date = moment(this.preBookingData.cleaning_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
        const time = moment(this.preBookingData.cleaning_time, 'HH:mm').format('HH:mm:ss')
        const bookingDate = date + ' ' + time
        const submitData = {
          user_id: this.user.id,
          booking_date: bookingDate,
          work_hour: this.preBookingData.work_hour,
          province_id: this.preBookingData.province_id,
          platform: 'website'
        }
        this.$store.dispatch('booking/SAVE_NO_CLEANER_EVENT', submitData)
      },
      loadByFilters (filters) {
        this.page = 0
        this.isExcellent = filters.isExcellent
        this.vaccinatedProfessional = filters.vaccinatedProfessional
        this.covidTestProfessional = filters.covidTestProfessional
        this.languageIds = filters.languageIds
        this.loadProfessionals()
      },
      loadProfessionals () {
        if (this.page === 0) {
          this.$store.commit('booking/SET_PROFESSIONAL_LIST', null)
        }

        const submitData = {
          user_id: this.userId,
          page: this.page,
          limit: this.limit,
          service_id: this.serviceId,
          province_id: this.preBookingData.province_id,
          cleaning_date: this.preBookingData.cleaning_date,
          cleaning_time: this.preBookingData.cleaning_time,
          work_hour: this.preBookingData.work_hour,
          user_place_id: this.preBookingData.user_place_id,
          latitude: this.latitude,
          longitude: this.longitude,
          is_excellent: this.isExcellent,
          vaccinated_professional: this.vaccinatedProfessional,
          covid_test_professional: this.covidTestProfessional,
          language_ids: this.languageIds
        }
        this.$store.dispatch('booking/LOAD_PROFESSIONAL_LIST', submitData)
      },
      loadMoreProfessionals () {
        this.page++
        this.loadProfessionals()
      },
      updateBookingTime () {
        this.newBookingTime = this.bookingState.nextAvailableData.time
      },
      handleScroll () {
        if (window.scrollY > 96 && this.$mq.phone) {
          this.$refs.sectionChooseCleaner.classList.add('additional-margin-top')
        } else {
          this.$refs.sectionChooseCleaner.classList.remove('additional-margin-top')
        }
      },
      getUserPlaceLocation (id) {
        for (let key in this.bookingState.userPlaces) {
          const userPlace = this.bookingState.userPlaces[key]
          if (userPlace.id === id) {
            return {latitude: Number(userPlace.latitude), longitude: Number(userPlace.longitude)}
          }
        }
      },
      backToBookingPage () {
        this.$router.push('/booking/new')
      },
      showPinLocationModal () {
        if (!this.hasPlaceLocation) {
          const provinceId = this.preBookingData.province_id
          let lat = this.globalState.citiesLocations[provinceId].lat
          let lng = this.globalState.citiesLocations[provinceId].lng
          this.$refs.pinLocationModal.show(lat, lng, true)
        } else {
          this.$refs.pinLocationModal.show(this.latitude, this.longitude, false)
        }
      }
    },
    mounted () {
      this.$store.commit('booking/SET_BOOKING_CURRENT_STEP', 2)
      if (this.user) {
        this.userId = this.user.id
      }

      // Compare work hours for clearing extras when user back to select professional again
      if (this.preBookingData.work_hour !== this.preBookingData.init_work_hour) {
        this.$store.commit('booking/UPDATE_PRE_BOOKING_DATA', {key: 'work_hour', value: this.preBookingData.init_work_hour})
      }
      if (this.preBookingData.user_place) {
        this.latitude = Number(this.preBookingData.user_place.latitude)
        this.longitude = Number(this.preBookingData.user_place.longitude)
        this.hasPlaceLocation = (this.latitude && this.longitude)
      }
      if (!this.latitude && !this.longitude) {
        this.showPinLocationModal()
      }
      let backupSelectedProfessional = null
      if (this.selectedProfessional) {
        backupSelectedProfessional = {...this.selectedProfessional}
      }
      this.$store.commit('booking/SET_SELECTED_PROFESSIONAL', null)
      // Check firebase login redirect
      getRedirectResult(firebaseAuth).then((result) => {
        if (result && result.user) {
          this.$store.commit('booking/SET_SELECTED_PROFESSIONAL', backupSelectedProfessional)
        }
      }).catch((error) => {
        console.log(error)
      })
      // Set total price and professional income to zero
      const costData = {
        totalPrice: null
      }
      // Check service items to calculate total price
      if (this.preBookingData.service_items) {
        costData.totalPrice = serviceHelpers.getTotalPriceOfServiceItems(this.preBookingData.service_items)
      }
      this.$store.commit('booking/SET_BOOKING_COST', costData)

      if (!this.preBookingData) {
        this.backToBookingPage()
      } else {
        this.serviceId = parseInt(this.preBookingData.service_id)
        this.selectedProvinceId = parseInt(this.preBookingData.province_id)
        this.$store.commit('booking/SET_PROFESSIONAL_LIST', null)
        if (this.preBookingData.province_id && this.hasPlaceLocation) {
          this.loadProfessionals()
        }
      }
      userEventLogHelpers.logEvent('view_professional_list', {
        province_id: this.selectedProvinceId,
        service_id: this.serviceId
      })
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/steps/ChooseCleaner.vue